export const supportsWebp = document.documentElement.classList.contains('webp');
